var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditLine = function SvgEditLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EditLine_svg__Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "EditLine_svg__Vector",
    d: "M4.16659 15.5597H7.21104L15.2027 7.568C15.4026 7.3681 15.5612 7.13079 15.6694 6.8696C15.7776 6.60842 15.8333 6.32848 15.8333 6.04578C15.8333 5.76308 15.7776 5.48314 15.6694 5.22196C15.5612 4.96077 15.4026 4.72345 15.2027 4.52355C15.0028 4.32365 14.7655 4.16508 14.5043 4.05689C14.2431 3.94871 13.9632 3.89303 13.6805 3.89303C13.3978 3.89303 13.1179 3.94871 12.8567 4.05689C12.5955 4.16508 12.3582 4.32365 12.1583 4.52355L4.16659 12.5152V15.5597Z",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "EditLine_svg__Vector_2",
    d: "M11.25 5.41667L13.75 7.91667",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgEditLine;